/**
 * Job Board — API client.
 * All calls go to /api/jb/* via REACT_APP_BACKEND_URL.
 */
const BASE = process.env.REACT_APP_BACKEND_URL;

async function req(method, path, body = null, token = null) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw { status: res.status, detail: data.detail || 'Request failed' };
  return data;
}

// ── Auth ──────────────────────────────────────────────────────────────────────
export const jbApi = {
  employerRegister: (body) => req('POST', '/api/jb/employer/register', body),
  employerLogin:    (body) => req('POST', '/api/jb/employer/login', body),
  seekerRegister:   (body) => req('POST', '/api/jb/seeker/register', body),
  seekerLogin:      (body) => req('POST', '/api/jb/seeker/login', body),
  me:               (token) => req('GET', '/api/jb/auth/me', null, token),

  // Jobs (public)
  listJobs:    (params = {}) => req('GET', `/api/jb/jobs?${new URLSearchParams(params)}`),
  hotlist:          (limit = 8)  => req('GET', `/api/jb/jobs/hotlist?limit=${limit}`),
  homepageFeatured: ()           => req('GET', `/api/jb/jobs/homepage-featured`),
  searchJobs:  (params = {}) => req('GET', `/api/jb/jobs/search?${new URLSearchParams(params)}`),
  getJob:      (id, token)   => req('GET', `/api/jb/jobs/${id}`, null, token),

  // Applications
  apply:              (body, token) => req('POST', '/api/jb/applications', body, token),
  seekerApplications: (token)       => req('GET', '/api/jb/seeker/applications', null, token),

  // Notifications
  notifications:   (token)    => req('GET', '/api/jb/notifications', null, token),
  unreadCount:     (token)    => req('GET', '/api/jb/notifications/unread-count', null, token),
  markAllRead:     (token)    => req('PUT', '/api/jb/notifications/read-all', null, token),
  markRead:        (id, token)=> req('PUT', `/api/jb/notifications/${id}/read`, null, token),

  // Employer portal
  employerJobs:       (token, params = {}) => req('GET', `/api/jb/employer/jobs?${new URLSearchParams(params)}`, null, token),
  employerApplications:(token, params = {}) => req('GET', `/api/jb/employer/applications?${new URLSearchParams(params)}`, null, token),
  getJobApplicants:   (jobId, token)   => req('GET', `/api/jb/employer/jobs/${jobId}/applicants`, null, token),
  createJob:          (body, token)    => req('POST', '/api/jb/employer/jobs', body, token),
  updateJob:          (jobId, b, token)=> req('PUT',  `/api/jb/employer/jobs/${jobId}`, b, token),
  deleteJob:          (jobId, token)   => req('DELETE',`/api/jb/employer/jobs/${jobId}`, null, token),
  updateAppStatus:    (appId, b, token)=> req('PUT',  `/api/jb/employer/applications/${appId}/status`, b, token),
  createCheckout:     (body, token)    => req('POST', '/api/jb/payments/create-checkout-session', body, token),
  pollPayment:        (sessionId)      => req('GET',  `/api/jb/payments/status/${sessionId}`),
  updateEmployer:     (body, token)    => req('PUT',  '/api/jb/employer/profile', body, token),

  // Seeker portal  
  seekerProfile:      (token)          => req('GET',  '/api/jb/auth/me', null, token),
  updateSeeker:       (body, token)    => req('PUT',  '/api/jb/seeker/profile', body, token),
  firstBriefcaseIntake: (body, token)  => req('POST', '/api/jb/first-briefcase/intake', body, token),
};
